import React from 'react';
import LazyImage from './LazyImage';
import './GallerySlider.css';

interface GalleryImage {
  id: number;
  src: string;
  alt: string;
}

const galleryImages: GalleryImage[] = [
  { id: 1, src: '/images/Slide_Gallery/0G5A2845.JPG', alt: 'Gallery 1' },
  // { id: 2, src: '/images/Slide_Gallery/0G5A2847.JPG', alt: 'Gallery 2' },
  // { id: 3, src: '/images/Slide_Gallery/0G5A2848.JPG', alt: 'Gallery 3' },
  { id: 4, src: '/images/Slide_Gallery/0G5A2849.JPG', alt: 'Gallery 4' },
  { id: 5, src: '/images/Slide_Gallery/0G5A2850.JPG', alt: 'Gallery 5' },
  { id: 6, src: '/images/Slide_Gallery/0G5A2851.JPG', alt: 'Gallery 6' },
  { id: 7, src: '/images/Slide_Gallery/0G5A2854.JPG', alt: 'Gallery 7' },
  { id: 8, src: '/images/Slide_Gallery/0G5A2855.JPG', alt: 'Gallery 8' },
  { id: 9, src: '/images/Slide_Gallery/0G5A2865.JPG', alt: 'Gallery 9' },
  { id: 10, src: '/images/Slide_Gallery/0G5A2870.JPG', alt: 'Gallery 10' },
  { id: 11, src: '/images/Slide_Gallery/0G5A2874.JPG', alt: 'Gallery 11' },
  { id: 12, src: '/images/Slide_Gallery/0G5A2887.JPG', alt: 'Gallery 12' },
  { id: 13, src: '/images/Slide_Gallery/0G5A2900.JPG', alt: 'Gallery 13' },
  { id: 14, src: '/images/Slide_Gallery/0G5A2905.JPG', alt: 'Gallery 14' },
  { id: 15, src: '/images/Slide_Gallery/0G5A2906.JPG', alt: 'Gallery 15' },
  { id: 16, src: '/images/Slide_Gallery/0G5A2916.JPG', alt: 'Gallery 16' },
  { id: 17, src: '/images/Slide_Gallery/0G5A2945.JPG', alt: 'Gallery 17' },
  { id: 18, src: '/images/Slide_Gallery/0G5A2947.JPG', alt: 'Gallery 18' },
  { id: 19, src: '/images/Slide_Gallery/0G5A2948.JPG', alt: 'Gallery 19' },

  
 
];

const GallerySlider: React.FC = () => {
  const firstRow = galleryImages.filter((_, index) => index % 2 === 0);
  const secondRow = galleryImages.filter((_, index) => index % 2 === 1);

  const renderRow = (row: GalleryImage[], rowClassName: string) => (
    <div className={`gallery-marquee-row ${rowClassName}`}>
      <div className="gallery-marquee-track">
        {[...row, ...row].map((image, index) => (
          <figure className="gallery-marquee-card" key={`${rowClassName}-${image.id}-${index}`}>
            <LazyImage src={image.src} alt={image.alt} />
          </figure>
        ))}
      </div>
    </div>
  );

  return (
    <div className="gallery-slider-container">
      {renderRow(firstRow, 'gallery-row-top')}
      {renderRow(secondRow, 'gallery-row-bottom')}
    </div>
  );
};

export default GallerySlider;
